import { render, staticRenderFns } from "./CouponSection.vue?vue&type=template&id=465d0ed9&scoped=true&"
import script from "./CouponSection.vue?vue&type=script&lang=js&"
export * from "./CouponSection.vue?vue&type=script&lang=js&"
import style0 from "./CouponSection.vue?vue&type=style&index=0&id=465d0ed9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465d0ed9",
  null
  
)

export default component.exports